import React from "react";
import { View, Text, StyleSheet, TouchableOpacity, AsyncStorage, WebView, TouchableWithoutFeedback,
	Dimensions, Image, ImageBackground, SectionList, I18nManager as RNI18nManager, Platform } from "react-native";

import * as Font from 'expo-font';
import { color } from "../config/color"
import store from "../config/config.json"

import { Ionicons, Octicons, Feather } from "@expo/vector-icons";
import { format, parse, isThisHour } from 'date-fns'

import PlaceholderComp from "../utilities/PlaceholderComp";
import * as firebase from "firebase";
import TopBar from "../widgets/TopBar";
import Main from "../widgets/Main";
import Menu from "../widgets/Menu";
import HoverableOpacity from "../widgets/HoverableOpacity";
import { FlatList } from "react-native-gesture-handler";
import {StoryWrapper} from '../widgets/story.styled';
import i18n from 'i18n-js';
import MainComponent from "../utilities/MainComponent";
import moment from 'moment';
import AppContext, {AppProvider} from "../utilities/AppContext"
import { da } from "date-fns/locale";

export default class OffersScreen extends MainComponent {	
	
	static path = 'offers';

	state = {
		store: {},
		title: "Offers",
		showCart: false,
		orderCount : 0,
		stories: [],
		totalPrice : 0,		
		deliveryData : {area: "", timings : ""},
		offerData : undefined,
		showBack 		: false,
		showMenu 		: false,
		showFullMode 	: true,
		data : [],
		mainData : [],
		fakeData : new Array(7).fill({})
	};
	
	static navigationOptions = {
		headerShown: false
	};

	changeState(states){
		if(states.openOrder != undefined && states.openOrder == true)
			this.reviewOrder()
		else
			this.setState(states)
	}

	constructor(props) {
		super(props);
		
		this.handleScroll = this.handleScroll.bind(this)
		this.changeState = this.changeState.bind(this)

		let screenWidth   = window.innerWidth;
		let screenHeight  = window.innerHeight;
		
		this.state.height = screenHeight
		this.state.width  = screenWidth
				
		if(screenWidth < color.screenLimit){
			this.state.showFullMode = false;			
		}else{
			this.state.showFullMode = true;			
		}

		moment.locale('en');
	}

	componentDidMount() {	

		Dimensions.addEventListener('change', (e) => {
			const { width, height } = e.window;
			this.setState({height: height, width: width})
			if(width < color.screenLimit){
				this.setState({showFullMode: false});			
			}else{
				this.setState({showFullMode: true});			
			}
		})

		this.getDetails()
	}

	getDetails = async () => {		
		
		await Font.loadAsync(color.appFonts);

		let that = this
		this.state.mainData = []
		that.state.offerData = undefined

		firebase.database().ref('promotions/' + store.storeId).orderByChild("promotionType").startAt(2).once("value", function(snapshot) {
			snapshot.forEach(function(childSnapshot) 
			{						
				let mData = snapshot.val()
				if (mData != undefined){				
					let promoData = Object.keys(mData).map(function(key) {
						mData[key].key = key;
						return mData[key];
					})

					if(promoData.length > 0)
					{
						promoData.forEach(mPromotion => 
						{
						 	if(mPromotion.promotionType == 2 && mPromotion.status == true)
							{
								var startDate = new Date().getTime()
								var endDate  = mPromotion
								var d = ((endDate - startDate)/1000).toFixed(0)
								d = Number(d);
								if(d < 10)
								{

								}
								else
								{
									that.state.offerData = mPromotion	
									var mMainList = []				

									if(mPromotion.productsList != undefined)
									{
										mPromotion.productsList.forEach(mProduct => {
											if(mProduct.status == true)
											{
												let mItem = {isSelected: false, data: mProduct}
												mMainList.push(mItem)													
											}	
										})
									}

									if(mPromotion.categoriesList != undefined)
									{
										mPromotion.categoriesList.forEach(mCategory => {
											
											let itemKeys = Object.keys(mCategory.items)
											itemKeys.forEach(mKey => {
												var mProduct = mCategory.items[mKey]
												if(mProduct.status == true)
												{
													let mItem = {isSelected: false, data: mProduct}
													mMainList.push(mItem)													
												}	
											})
										})
									}
									
									that.setState({offerData: that.state.offerData, data: JSON.parse(JSON.stringify(mMainList)), mainData: mMainList})
									that.updateCart()
									that.setupTimer()
								}
							}							
						})
					}
				}
			});

			if(that.state.offerData == undefined)
			{
				that.props.navigation.navigate('menu');
			}

		}.bind(this), function(error) { 
			console.log(error)
		});

		this.updateCart()
	}

	setupTimer()
	{
		var that = this
		if(this.state.offerData != undefined)
		{
			const x = setInterval(()=>{
				if( this.state.offerData == undefined) {
				  clearInterval(x)
				}else {				 
					
					var startDate = new Date().getTime()
					var endDate  = this.state.offerData.endDate
					var d = ((endDate - startDate)/1000).toFixed(0)
					d = Number(d);
					if(d <= 0)
					{
						that.props.navigation.navigate('menu');
						that.setState({offerData: undefined})		
						try{
							clearInterval(x)
						}catch(e){}
						return
					}	

					this.setState({
						offerData : this.state.offerData})
				}
			  },1000)
		}
	}

	updateCart = async () => {
		try {

			var value = await AsyncStorage.getItem(store.storeData)
			if (value == undefined)
				value = {}
			else
				value = JSON.parse(value)			
			
			this.state.store = value

			if(this.state.store.orderLimit == undefined)
				this.state.store.orderLimit = 0
			if(this.state.store.todayOrdersCount == undefined)
				this.state.store.todayOrdersCount = 0

		} catch (error) {
			console.log(error)
		}

		// Set the key-value pairs for the different languages you want to support.
		var that = this
		firebase.database().ref('stores/' + store.storeId).once("value", function(snapshot) {			
			   
			let data = snapshot.val()
			if(data != undefined)
			{
				AsyncStorage.setItem(store.storeData, JSON.stringify(data)).then((value) => {});
				this.state.store = data
				if(this.state.store.orderLimit == undefined)
					this.state.store.orderLimit = 0
				if(this.state.store.todayOrdersCount == undefined)
					this.state.store.todayOrdersCount = 0
				if(this.state.store.todayOrdersCount >= this.state.store.orderLimit)
					this.state.store.state = false
					
				that.setState({store: this.state.store})		 
			}

		}.bind(this), function(error) { 
			console.log(error)
		});

		try{
			if(this.state.store.enableDelivery || this.state.store.enablePickup)
			{
				var value = await AsyncStorage.getItem(store.delivery)
				if (value == undefined || value == null || value == "null")
					value = {area: "", timings : ""}
				else
				{
					if(!this.state.store.enablePickup && JSON.parse(value).branch != undefined)
						value = {area: "", timings : ""}
					if(!this.state.store.enableDelivery && JSON.parse(value).area != undefined)
						value = {area: "", timings : ""}
						
					this.state.deliveryData = JSON.parse(value)
					this.context.setDeliveryData(JSON.parse(value))
				}
			}
			
		} catch (error) {
			//console.log(error)
		}

		try{			

			value = await AsyncStorage.getItem(store.key)
			if (value == undefined)
				value = []
			else
			{
				try{
					value = JSON.parse(value)
				} catch (error) {
					value = []
				}
			}			

			if(value.length > 0)
			{
				const {reset, ordersCount, mainTotalPrice, selectedIds,  ordersData} = this.calculateTotalOrderPrice(
						value, this.state.store, this.state.deliveryData, this.state.applyPromo == true ? this.state.promoData : undefined 
				)
				if(reset)
				{
					await AsyncStorage.removeItem(store.key)
					this.setState({isLoading: false})
				}
				else
					this.setState({showCart: true, totalPrice: mainTotalPrice, orderCount: ordersCount, selectedIds: selectedIds, orderData: ordersData})
			}
			else
				this.setState({isLoading: false})

		} catch (error) {
			console.log(error)
			this.setState({isLoading: false})
		}
	}

   listRowPressed(item){
		this.context.onUpdate = this.updateCart.bind(this)
		this.context.itemData = item.data
		this.context.offerData = this.state.offerData

		this.props.navigation.navigate('details', {
			item: item.data.key,
		});				
	}

	setCategory(mCat){

		let index = mCat.index	
		mCat.isExpanded = !mCat.isExpanded
		this.state.mainData[index].isExpanded = mCat.isExpanded;
		var categories = []		
		
		var mIndex = 0
		this.state.mainData.map(category => {											
			if(!category.isExpanded){
				let mCategory  = {index: mIndex, isExpanded: false, category: category.category, data: [], dataCount: category.dataCount}
				categories.push(mCategory)
			}else{
				let mCategory  = {index: mIndex, isExpanded: true, category: category.category, data: category.data, dataCount: category.dataCount}
				categories.push(mCategory)
			}

			mIndex += 1
		})

		this.setState({data: categories, mainData: this.state.mainData})
	}

	/**
	 * 
	 *	IBOutlets 
	 * 
	 */

	openArea(){
		this.context.onUpdate = this.onSelectArea.bind(this)
		this.props.navigation.navigate('area');		
	}

	onSelectArea = async data => {	
		this.setState({deliveryData: data});
		await AsyncStorage.setItem(store.delivery, JSON.stringify(data))
		const {ordersCount, mainTotalPrice, selectedIds,  ordersData} = this.calculateTotalOrderPrice(
			this.state.orderData, this.state.store, this.state.deliveryData, this.state.promoData)					
		this.setState({totalPrice: mainTotalPrice, orderCount: ordersCount, selectedIds: selectedIds, orderData: this.state.orderData})
	};

	openScheduleTimings(){
		this.context.onUpdate = this.onSelectTimings.bind(this)
		this.props.navigation.navigate('scheduled');
	}

	onSelectTimings = async data => {
		let deliveryData = {area: data.area, timings: data.timings}
		this.setState({deliveryData: deliveryData});
		await AsyncStorage.setItem(store.delivery, JSON.stringify(deliveryData))
	};

	/**
	 * 
	 * 
	 */
	reviewOrder(){

		if(this.state.store.enableDelivery)
		{
			if(this.state.deliveryData.area != undefined)
			{
				if(this.state.deliveryData == undefined || this.state.deliveryData.area == undefined
					|| this.state.deliveryData.area === {} || this.state.deliveryData.area == ''){
					this.openArea()
					return
				}

				if(this.state.deliveryData == undefined || this.state.deliveryData.area == undefined
					|| this.state.deliveryData.timings === {} || this.state.deliveryData.timings == ''){
					this.openScheduleTimings();
					return
				}
			}
		}
			
		if(this.state.applyPromo == true && this.state.promoData != undefined)
		{
			this.context.onUpdate = this.updateCart.bind(this)
			AsyncStorage.setItem(store.promo, JSON.stringify(this.state.promoData)).then((value) => {
				this.props.navigation.navigate("review");
			});
		}
		else
		{
			AsyncStorage.removeItem(store.promo).then((value) => {
				this.context.onUpdate = this.updateCart.bind(this)
				this.props.navigation.navigate("review");
			});
		}
	}

	moveToOrder(){

		var minOrderValueRequired = this.state.store.minimumOrder
		if(this.state.deliveryData.area != undefined)
		{
			minOrderValueRequired = this.state.deliveryData.area.minOrderPrice
		}


		if(this.state.totalPrice < minOrderValueRequired)
			return;

		this.context.onUpdate = this.updateCart.bind(this)
		this.props.navigation.navigate("review");
	}

	/****
	 * 
	 * 
	 * 
	 * 
	 * 
	 */

	handleScroll(event){
		this.setState({
			scrollOffset: event.nativeEvent.contentOffset.y
		})
	}

	/**
	 * 
	 * 
	 */
	showCategoryData(data)
	{
		this.setState({categoryData: data})
	}

	/**
	 * 
	 * 
	 * 
	 * 
	 * 
	 * 
	 * 
	 */

	/**
	 * 
	 * 
	 * 
	 * 
	 */

	renderSectionHeader = ({ section }) => 
	{
		let scrollOffsetRequired = this.state.headerHeight

		var height = 255
		if(this.state.scrollOffset > scrollOffsetRequired && !this.state.showFullMode && section.index == 0){
			//height += 50
		}
		var name 	= section.category.name
        var details = section.category.details;

        if(i18n.locale != this.state.store.defaultLanguage){
            name    = section.category.nameSecondary
            details = section.category.detailsSecondary
        }

        if(name == undefined || name == "")
            name = section.category.name
        if(details == undefined || details == "")
            details = section.category.details

		return (
			<View  style={{height: height, backgroundColor: "white"}}>
				
				{ height > 55 && !this.state.showFullMode && (
					<View style={{height: 50}}/>
				)}

				<View  style={{ flexDirection: "row", height: 55, justifyContent: "center", alignContent: "center", alignItems:"center" }}>
						<View  style={{flex:1, marginLeft: 15, justifyContent: "center"}}>
							<Text style={{textAlign:'left', fontFamily: 'main-regular', color: "black"  , fontSize: 18 }}>{name}</Text>
							<Text style={{textAlign:'left', fontFamily: 'main-regular', color: color.detailsColor, fontSize: 12 }}>{details}</Text>
						</View>
						{ !section.isExpanded && (<Text style={{ fontFamily: 'main-regular',marginLeft: "auto", marginRight: 10, fontWeight: "bold", color: color.detailsColor  , fontSize: 16 }}> {section.dataCount} </Text>)}	
						<TouchableOpacity style={{marginLeft: "auto", marginRight: 10}} 
									onPress={() => { this.setCategory(section) }}
						>
							{ section.isExpanded && (<Ionicons name="ios-arrow-down" size={24} color="black" />)}	
							{ !section.isExpanded && (<Ionicons name="ios-arrow-up" size={24} color="black" />)}	
						</TouchableOpacity>
				</View>
				<View style={{height: 1, backgroundColor:color.bigSeparator}}/>
			</View>
		  );
	}

	renderListItem = ({item, index}) => {

		var name 	= item.data.name
        if(i18n.locale != this.state.store.defaultLanguage){
            name    = item.data.nameSec
		}
		
		var imageUrl = ""
		if(item.data.images != undefined && item.data.images.length > 0)
			imageUrl = item.data.images[0]

        if(name == undefined || name == "")
            name = item.data.name

		var marginLeft  = 10
		var marginRight = 10

		var width = "30%"
		var height = 250

		var price = +item.data.price
		price = price.toFixed(3)
		var priceText = price
		var discountPrice = 0
		if(price == 0)
		{
			priceText = "-"
			if(RNI18nManager.isRTL)
				discountPrice = 0 + " " + i18n.t('currency.' + this.state.store.currency.toLowerCase())
			else
				discountPrice = i18n.t('currency.' + this.state.store.currency.toLowerCase()) + " " + 0
		}
		else
		{
			// discount is 
			if(this.state.offerData != undefined)
			{
				if (this.state.offerData.type == 10) // Fixed price
					discountPrice = price - +this.state.offerData.amount

				if (this.state.offerData.type == 11) // percentage
					discountPrice = price -  (+this.state.offerData.amount * price/100)
				
				if(discountPrice < 0)
					discountPrice = 0

				if(RNI18nManager.isRTL)
					discountPrice = discountPrice + " " + i18n.t('currency.' + this.state.store.currency.toLowerCase())
				else
					discountPrice = i18n.t('currency.' + this.state.store.currency.toLowerCase()) + " " + discountPrice
			}

			if(RNI18nManager.isRTL)
				priceText = price + " " + i18n.t('currency.' + this.state.store.currency.toLowerCase())
			else
				priceText = i18n.t('currency.' + this.state.store.currency.toLowerCase()) + " " + price
		}

		return (
			<View style={{height: height, marginLeft: marginLeft, marginRight: marginRight, width: width}}>
					<ImageBackground 
						source={imageUrl}
						style={{height: 160, width: "100%", overflow:"visible"}}
						imageStyle={{ borderRadius: 10}}
						/>

					<Text numberOfLines={1} style={{marginTop: 5, textAlign:"left", fontFamily: "main-bold", color:'black', fontSize:14}}>{name}</Text>			
					<HoverableOpacity style={{marginTop: 5, width: "100%", height: 35, borderColor:"#E5E5E9", borderRadius: 5, borderWidth: 1, marginBottom: 15, justifyContent: "center", alignItems: "center", alignContent: "center"}}
							onPress={() => this.listRowPressed(item) }
					>
						<Text style={{ fontFamily: 'main-regular', color: this.state.store.primaryColor, fontSize: 9, fontFamily: "main-regular", textAlign: "center", textDecorationLine: 'line-through', textDecorationStyle: 'solid'}}>{priceText}</Text>
						<Text style={{ fontFamily: 'main-bold', color: "black", fontSize: 11, fontFamily: "main-regular", textAlign: "center"}}>{discountPrice}</Text>
					</HoverableOpacity>
			</View>
		);
	}

	/**
	 * 
	 */
	

	renderHeader(that){
		//var that = this
			
		var h = ""
		var m = ""
		var s = ""
		if(this.state.offerData != undefined)
		{
			var startDate = new Date().getTime()
			var endDate  = this.state.offerData.endDate
			var d = ((endDate - startDate)/1000).toFixed(0)
			d = Number(d);
			h = Math.floor(d / 3600).toString();
			m = Math.floor(d % 3600 / 60).toString();
			s = Math.floor(d % 3600 % 60).toString();			
			
			if(h.length == 1)
				h = "0" + h
			if(m.length == 1)
				m = "0" + m
			if(s.length == 1)
				s = "0" + m
		}

		return (
			<View style={{flex:1}} onLayout={event => {
				const layout = event.nativeEvent.layout;
				this.state.headerHeight = layout.height
			  }}>

				<View style={{height: 8, backgroundColor:color.bigSeparator, justifyContent: "center"}}/>

				{ this.state.offerData != undefined &&(
					<View style={{backgroundColor: color.bigSeparator, height: 200}}> 
						
						<View style={{backgroundColor: 'white', borderRadius: 8, marginLeft: 10, marginRight: 10, height: 190, justifyContent: "center", alignItems: "center" }}>	
							
								<div style={{margin: 10, width: 49, height: 49}}>
									<svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 110 135">										
										<g id="PromoCode">
											<g id="discount" transform="translate(-47.857 4.109)">
											<g id="Group_28" data-name="Group 28" transform="translate(54.857)">
												<g id="Group_27" data-name="Group 27">
												<path id="Path_103" data-name="Path 103" d="M138.567,0H66.647a11.79,11.79,0,0,0-11.79,11.79V120.26a4.716,4.716,0,0,0,2.8,4.274,4.863,4.863,0,0,0,5.011-.884l9.874-9.137,12.085,10.759a4.458,4.458,0,0,0,6.042,0l11.937-10.759,11.937,10.759a4.716,4.716,0,0,0,6.042,0l12.085-10.759,9.874,9.137a4.863,4.863,0,0,0,5.011.884,4.716,4.716,0,0,0,2.8-4.274V11.79A11.79,11.79,0,0,0,138.567,0Zm5.9,117.312-8.7-7.958a4.569,4.569,0,0,0-6.19,0L117.64,120.113,105.7,109.354a4.651,4.651,0,0,0-6.19,0L87.575,120.113,75.638,109.354a4.569,4.569,0,0,0-6.19,0l-8.7,7.958V11.79a5.9,5.9,0,0,1,5.9-5.9h71.92a5.9,5.9,0,0,1,5.9,5.9V117.312Z" transform="translate(-54.857)" fill="#a4a4a4"/>
												<path id="Path_104" data-name="Path 104" d="M122.066,244.132H149.33a2.948,2.948,0,0,0,0-5.9H122.066a2.948,2.948,0,1,0,0,5.9Z" transform="translate(-100.991 -171.033)" fill="#a4a4a4"/>
												<path id="Path_105" data-name="Path 105" d="M175.416,284.212H122.066a2.948,2.948,0,1,0,0,5.9h53.351a2.948,2.948,0,1,0,0-5.9Z" transform="translate(-100.991 -204.039)" fill="#a4a4a4"/>
												<path id="Path_106" data-name="Path 106" d="M175.416,330.71H122.066a2.948,2.948,0,0,0,0,5.9h53.351a2.948,2.948,0,0,0,0-5.9Z" transform="translate(-100.991 -237.42)" fill="#a4a4a4"/>
												<path id="Path_107" data-name="Path 107" d="M159.817,76.174a9.874,9.874,0,1,0-9.874-9.874A9.874,9.874,0,0,0,159.817,76.174Zm0-13.854a3.979,3.979,0,1,1-3.979,3.979A3.979,3.979,0,0,1,159.817,62.32Z" transform="translate(-123.12 -40.508)" fill={this.state.store.primaryColor}/>
												<path id="Path_108" data-name="Path 108" d="M238.184,134.792a9.874,9.874,0,0,0,0,19.749h0a9.874,9.874,0,0,0,0-19.749Zm0,13.853a3.979,3.979,0,1,1,3.979-3.979A3.979,3.979,0,0,1,238.184,148.645Z" transform="translate(-179.381 -96.769)" fill={this.state.store.primaryColor}/>
												<path id="Path_109" data-name="Path 109" d="M160.3,99.993a2.948,2.948,0,0,0,2.063.884,2.652,2.652,0,0,0,2.063-.884l31.539-31.539a2.948,2.948,0,0,0-4.127-4.127L160.3,95.719A3.1,3.1,0,0,0,160.3,99.993Z" transform="translate(-129.943 -45.758)" fill={this.state.store.primaryColor}/>
												</g>
											</g>
											</g>
										</g>
									</svg>
								</div>

								<View style={{marginTop: 5, flexDirection: "row"}}>

									<Text style={{ fontFamily: 'main-bold', color: 'black', width: 25, height: 33, borderRadius: 2, fontSize: 24, backgroundColor: color.bigSeparator, textAlign: "center"}}>{h.length > 1 ? h.charAt(0): 0}</Text>
									<Text style={{ marginLeft: 5, fontFamily: 'main-bold', color: 'black', width: 25, height: 33, borderRadius: 2, fontSize: 24, backgroundColor: color.bigSeparator, textAlign: "center"}}>{h.length > 1 ? h.charAt(1): 0}</Text>

									<Text style={{ marginLeft: 5, fontFamily: 'main-bold', color: 'black', width: 25, height: 33, borderRadius: 2, fontSize: 24, textAlign: "center"}}>:</Text>

									<Text style={{ marginLeft: 5, fontFamily: 'main-bold', color: 'black', width: 25, height: 33, borderRadius: 2, fontSize: 24, backgroundColor: color.bigSeparator, textAlign: "center"}}>{m.length > 1 ? m.charAt(0): 0}</Text>
									<Text style={{ marginLeft: 5, fontFamily: 'main-bold', color: 'black', width: 25, height: 33, borderRadius: 2, fontSize: 24, backgroundColor: color.bigSeparator, textAlign: "center"}}>{m.length > 1 ? m.charAt(1): 0}</Text>

									<Text style={{ marginLeft: 5, fontFamily: 'main-bold', color: 'black', width: 25, height: 33, borderRadius: 2, fontSize: 24, textAlign: "center"}}>:</Text>

									<Text style={{ marginLeft: 5, fontFamily: 'main-bold', color: 'black', width: 25, height: 33, borderRadius: 2, fontSize: 24, backgroundColor: color.bigSeparator, textAlign: "center"}}>{s.length > 1 ? s.charAt(0): 0}</Text>
									<Text style={{ marginLeft: 5, fontFamily: 'main-bold', color: 'black', width: 25, height: 33, borderRadius: 2, fontSize: 24, backgroundColor: color.bigSeparator, textAlign: "center"}}>{s.length > 1 ? s.charAt(1): 0}</Text>
								</View>

								<View style={{marginTop: 20, width: "50%", height: 36, borderColor: color.bigSeparator, backgroundColor: color.bigSeparator, borderRadius: 5, borderWidth: 1, justifyContent: "center", alignItems: "center", alignContent: "center"}}
								>
									<Text style={{ fontFamily: 'main-regular', color: this.state.store.primaryColor,
													fontSize: 12, fontFamily: "main-bold", textAlign: "center"}}>{i18n.t("endOffers")}</Text>
								</View>
						</View>
					</View>
				)}

			</View>
		)
	}	
	
	renderDetails(){

		var opacity = 1
		var shouldDisable = false
		var minOrderValueRequired = this.state.store.minimumOrder
		if(this.state.deliveryData.area != undefined)
		{
			minOrderValueRequired = this.state.deliveryData.area.minOrderPrice
		}
		
		if(this.state.totalPrice < minOrderValueRequired || this.state.totalPrice == 0)
			shouldDisable = true;

		var showOrder = false;
		if(this.state.store.enableDelivery)
			showOrder = true

		if(this.state.store.enablePickup)
			showOrder = true

		if(this.state.totalPrice == undefined || this.state.totalPrice == "")
			this.state.totalPrice = 0

		var btnText = i18n.t("startOrdering")
		if(this.state.store.todayOrdersCount >= this.state.store.orderLimit)
			this.state.store.status = false

		if(this.state.store.status == false)
		{
			btnText = i18n.t("tempClosed")
			shouldDisable = true
			this.state.showCart = false
		}

		if(shouldDisable)
			opacity = .5

		var icoName = "ios-arrow-back"
		if(RNI18nManager.isRTL)
			icoName = "ios-arrow-forward"

		return (
			<View style={{flex: 1}}>
			
				<View style={styles.topBar}>															
					<View style={{width: '100%', position: "absolute", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
						<Text style={{color: 'black', fontFamily:"main-bold", textAlign: "center", fontSize: 16}}>{i18n.t("offers")}</Text>						
					</View>	
					<TouchableOpacity style={{height:40, width: 40, justifyContent: "center", alignContent: "center", alignItems: "center"}}
										onPress={() => { this.props.navigation.goBack(null) }} >
						<Ionicons name={icoName} size={24} color={'black'} />
					</TouchableOpacity>		
				</View>
				
				{this.state.data.length > 0 && (
						<FlatList
							style={{marginLeft: 5, marginRight: 5}}
							scrollEventThrottle={5}
							ListHeaderComponent={this.renderHeader(this)}   
							onScroll={this.handleScroll}
							data={this.state.data}
							renderItem={this.renderListItem}
							numColumns={3}
						/>
				)}				

				{this.state.categoryData == undefined && this.state.data.length == 0 && (
					this.state.fakeData.map((e, i) => <PlaceholderComp key={i} />)
				)}

				{this.state.showCart && showOrder && (
					<View style={{height: 64, backgroundColor:"white", justifyContent: "center", marginTop: "auto"}}>											
						<TouchableOpacity style={{marginLeft: 10, marginRight: 10, marginBottom: 8, marginTop: "auto", height:48, justifyContent: "center"}}
										onPress={() => { this.reviewOrder() }}
								>
							<View style={{flexDirection: "row", justifyContent: "center", alignItems: "center", flex:1, borderRadius: store.buttonCorner, backgroundColor:this.state.store.primaryColor}}>
								<View style={{backgroundColor: this.state.store.primaryDarkColor, borderRadius: 3, marginLeft: 10, width: 32, height: 32, alignItems: "center", justifyContent: "center", alignContent: "center"}}>
									<Text style={{ fontFamily: 'main-regular',color:'#FFF', fontWeight:"bold", fontSize:13, textAlign: "center"}}>{this.state.orderCount}</Text>
								</View>
								<Text style={{ fontFamily: 'main-regular',position: "absolute", marginLeft: "auto", marginRight: "auto", color:'#FFF', fontWeight:"bold", fontSize:14}}>{i18n.t("reviewOrder")}</Text>
								{ RNI18nManager.isRTL && (
									<Text style={{ fontFamily: 'main-regular',marginLeft: "auto", marginRight: 10, color:'#FFF', fontWeight:"normal", fontSize:13}}>{this.state.totalPrice.toFixed(3)} {i18n.t('currency.' + this.state.store.currency.toLowerCase())}</Text>		
								)}
								{ !RNI18nManager.isRTL && (
									<Text style={{ fontFamily: 'main-regular',marginLeft: "auto", marginRight: 10, color:'#FFF', fontWeight:"normal", fontSize:13}}>{i18n.t('currency.' + this.state.store.currency.toLowerCase())} {this.state.totalPrice.toFixed(3)}</Text>		
								)}
							</View>
						</TouchableOpacity>
					</View>
				)}	

				{!this.state.showCart && (
					<View style={{height: 64, backgroundColor:"white", justifyContent: "center", marginTop: "auto"}}>											
						<TouchableOpacity disabled={shouldDisable} style={{opacity: opacity, marginLeft: 10, marginRight: 10, marginBottom: 8, marginTop: "auto", height:48, justifyContent: "center"}}
										onPress={() => { this.moveToOrder() }}
								>
							<View style={{flexDirection: "row", justifyContent: "center", alignItems: "center", flex:1, borderRadius: store.buttonCorner, backgroundColor:this.state.store.primaryColor}}>
								<Text style={{ fontFamily: 'main-bold',position: "absolute", marginLeft: "auto", marginRight: "auto", color:'#FFF', fontSize:14}}>{btnText}</Text>
							</View>
						</TouchableOpacity>
					</View>
				)}	
			</View>
		)
	}

	render() {

		var that = this
	
		return (
			<AppContext.Consumer>
			{ (context) => (
				<View style={styles.container} ref={(ref) => { 
					this.context = context; 					
				}}>

					{this.state.showFullMode && (										
						
						<View style={styles.webContainer}>													
							<View style={{backgroundColor: color.backgroundColor, height: this.state.height, width: this.state.width * .33}}>
								{this.renderDetails()}						
							</View>	
							<Main {...this.state} changeMenu={this.changeMenu} />
						</View>					
					)}
					
					{!this.state.showFullMode &&(
						<View style={styles.container}>						
													
							<View style={{backgroundColor: color.backgroundColor, height: this.state.height}}>
								{this.renderDetails()}
							</View>	

						</View>
					)}
									
				</View>
			)}
			</AppContext.Consumer>
	  );
	}
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		backgroundColor: color.backgroundColor
	},
	topBar: {
        height: 50,
        flexDirection: "row", 
        alignContent: "center", 
        alignItems: "center"
    },
	webContainer: {
		flex: 1,
		flexDirection: "row",
	}
});
